<template>
  <div class="card">
      <div v-if="!isLoaded" class="content">
          <placeholder-content isLoad="true" />
      </div>
      <div v-if="isLoaded" class="card-header  border-bottom my-0">
          <h5 class="card-title text-uppercase">{{$t('_reports.Daily of total sales')}}</h5>
      </div>
      <div class="card-body">
          <v-chart v-if="isLoaded" class="chart" :option="option" autoresize/>
          <div class="no-data" v-if="hasData">
              <span>
                  <h3>{{ $t("No Data to Display") }}</h3>
              </span>
          </div>
      </div>
  </div>
  </template>
  
  <script>
  import {
      use
  } from "echarts/core";
  import {
      CanvasRenderer
  } from "echarts/renderers";
  import {
      BarChart
  } from "echarts/charts";
  import {
      TitleComponent,
      TooltipComponent,
      LegendComponent,
      GridComponent,
      ToolboxComponent,
  } from "echarts/components";
  import VChart, {
      THEME_KEY
  } from "@/plugins/vue-echarts";
  import moment from "moment";
  
  import PlaceholderContent from '@/plugins/PlaceholderContent.vue'
  use([
      CanvasRenderer,
      TitleComponent,
      TooltipComponent,
      LegendComponent,
      GridComponent,
      ToolboxComponent,
      BarChart,
  ]);
  import {
      localSave,
      localRead
  } from "@/store/lang";
  import {
      convertTimezone
  } from "@/common/tenancy/convertTimezone.js";
  
  import numeral from "numeral";
  export default {
      components: {
          VChart,
          PlaceholderContent
      },
      provide: {
          [THEME_KEY]: "default",
      },
      props: ["chartColumns", "yAxisText"],
      data() {
          let vm = this;
          return {
              lang: localRead("local"),
              hasData: false,
              option: {
                  textStyle: {
                      fontFamily: 'Sarabun',
                  },
                  tooltip: {
                      trigger: "axis",
                      textStyle: {
                          fontSize: 14,
                      },
                      axisPointer: {
                          type: "shadow",
                      },
                      formatter : function (params) {
                      var tempData = [];
                      let txt = '';
                      txt += '<div class="mb-1 pl-2 pr-5">';
                      // txt += moment(vm.chartColumns.start).locale(vm.lang).format('D MMM') + ' - ' + moment(vm.chartColumns.end).locale(vm.lang).format('D MMM');
                          for (let param of params) {
                              // console.log('param' ,param)
                              txt += vm.$t(param.data.month)+" "+param.data.year;
                              txt += '<div class="mt-1">';
                                //txt += '<h4 class="mt-1"><i class="fa fa-square" style="display:inline-block;margin-right:10px;border-radius:10px;width:10px;height:10px;color:'+param.data.color+';"></i><b>' + vm.$t('_reports.'+param.name)  + '</b></h4>';
                                  txt += '<span>';
                                      txt += '<span class="row">';
                                          txt += '<span class="col-sm-7">';
                                          txt += vm.$t("_Shipping.Number of Orders");
                                          txt += '<br>';
                                          txt += vm.$t("Sales");
                                          txt += '</span>';
  
                                          txt += '<span class="col-sm-5">'
                                          txt += ' ' + numeral(param.data.order).format("0,0");
                                          txt += '<br>';
                                          txt += ' ฿' + numeral(param.data.value).format("0,0.00") ;
                                          txt += '</span>';
                                      txt += '</span>';
                                  txt += '</span>';
                              txt += '</div>';
                          }
                          return  txt;
                      },
                  },
                  grid: {
                      top: 45,
                      bottom: 0,
                      left: 19,
                      right: 5,
                      containLabel: true,
                  },
                  xAxis: [{
                      type: "category",
                      data: [this.$t('_reports.sun'), this.$t('_reports.mon'), this.$t('_reports.tue'), this.$t('_reports.wed'), this.$t('_reports.thu'), this.$t('_reports.fri'), this.$t('_reports.sat')],
                      axisLabel: {
                          width: 100,
                          overflow: 'truncate',
                          interval: 0,
                      },
                      axisTick: {
                          alignWithLabel: true,
                      },
                  }, ],
                  yAxis: {
                      name: this.$t("Sales"),
                      type: "value",
                      nameTextStyle: {
                          align: "left",
                          padding: [0, 0, 5, -30],
                          fontSize: 13,
                      },
                      splitLine: {
                          lineStyle: {
                              type: "dashed"
                          }
                      },
                      axisLabel: {
                          formatter: function (value, index) {
                              var sales = value / 1000;
                              return sales + 'k';
                          }
                      }
                  },
                  legend: {
                      left: "right",
                      itemHeight: 10,
                      itemWidth: 10,
                  },
                  series: false,
              },
              isLoaded: false,
          };
      },
      async created(){
  
      },
      mounted() {
          let arr_series = [];
          this.$parent.chartColumns.forEach((value)=>{
              arr_series.push({
                  'name' : value['name'],
                  'value': value['datePayment'],
                  'order': value['dateOrders'],
                  'color': value['color'],
                  'month': this.$parent.monthName,
                  'year' : this.$parent.paramsQuery.year,
                  // 'itemStyle': {color: value['color']}
              });
          });
          this.option.yAxis.type = "value"
          this.option.series = [{
                                  data: arr_series,
                                  type: 'bar',
                                  itemStyle: {
                                      color: '#04A9F4',
                                  },
                              }]
          this.hasData = false;
          this.isLoaded = true;
      },
      methods: {
      },
      watch: {
  
      }
  };
  </script>
  
  <style scoped>
  .chart {
      height: 370px;
  }
  .no-data {
      position: absolute;
      opacity: 0.25;
      height: 100%;
      width: 100%;
      top: 0;
  }
  .no-data span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 1.5em;
      white-space: nowrap;
      text-align: center;
  }
  </style>


// WEBPACK FOOTER //
// src/components/tenancy/admin/report/SalesOrder/saledaily/SaledailyBarChart.vue